import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class ArquivosUploadService {
    private urlModulo = `${environment.urlAPI}/arquivosupload`;

    constructor(private http: HttpClient) { }

    /**
     * Recupera a lista de arquivos do sistema
     * @param uid ID do usuário
     * @returns Promise com a lista de arquivos
     */
    public getListaArquivos(uid: number): Promise<any> {
        const params = new HttpParams().set('uid', uid.toString());
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-lista`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.arquivos);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Grava um novo arquivo no sistema
     * @param obj Dados do arquivo
     * @returns Promise com o resultado da operação
     */
    public gravaArquivoUpload(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-salvar`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Atualiza um arquivo existente no sistema
     * @param obj Dados atualizados do arquivo
     * @returns Promise com o resultado da operação
     */
    public atualizaArquivoUpload(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-atualizar`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Baixa arquivo via API (envia auth e retorna blob para download)
     * @param codigo Código do arquivo
     * @param nomeArquivo Nome do arquivo para fallback do download
     * @returns Promise<{ blob: Blob; filename: string }> ou rejeita em erro
     */
    public downloadArquivo(codigo: number, nomeArquivo: string): Promise<{ blob: Blob; filename: string }> {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-download/${codigo}`, {
                responseType: 'blob',
                observe: 'response'
            }).subscribe({
                next: (response) => {
                    const blob = response.body as Blob;
                    let filename = nomeArquivo;
                    const disp = response.headers.get('Content-Disposition');
                    if (disp) {
                        const match = disp.match(/filename="?([^";\n]+)"?/);
                        if (match) filename = match[1].trim();
                    }
                    resolve({ blob, filename });
                },
                error: (err) => {
                    if (err.status === 404) {
                        reject(new Error('Documento não encontrado no armazenamento.'));
                    } else {
                        reject(err);
                    }
                }
            });
        });
    }

    /**
     * Exclui um arquivo do sistema
     * @param codigo Código do arquivo
     * @param tipoOrigem Tipo de origem do arquivo
     * @param codUsuario Código do usuário
     * @param arquivoCertificado Indica se é um arquivo de certificado
     * @returns Promise com o resultado da operação
     */
    public deletaArquivoUpload(codigo: number, tipoOrigem: string, codUsuario: number, arquivoCertificado: boolean = false): Promise<any> {
        const payload = {
            codigo: codigo,
            tipoOrigem: tipoOrigem,
            codUsuario: codUsuario,
            arquivoCertificado: arquivoCertificado
        };
        
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-excluir`, payload)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/arquivosupload.service.ts